<template>
  <div class="unsupported-browser text-center">
    <div>
      <h2>{{ $t('unsupportedBrowser.title') }}</h2>

      <p>{{ $t('unsupportedBrowser.notWork') }}<br />
        {{ $t('unsupportedBrowser.copyPaste') }}
      </p>

      <b-input ref="joinUrl" v-model="joinUrl"
        readonly
        @focus.native="selectJoinUrl"/>

      <p>{{ $t('unsupportedBrowser.pasteInto') }}</p>

      <p v-html="supportedBrowsersDisplayList.join(' | ')"></p>

      <b-button variant="link" @click="clickContinue">
        {{ $t('unsupportedBrowser.continue') }}
      </b-button>

      <img class="confused-bot"
        :src="require('@/assets/confused-bot.svg')" />
    </div>
  </div>
</template>

<script>
import {BROWSER, BROWSER_CHECK_STATUS} from '@/store/modules/system';
import windowUtils from '@/utils/window-utils';

const UnsupportedBrowser = {
  name: 'UnsupportedBrowser',

  data() {
    return {
      joinUrl: windowUtils.getWindowLocation().href
    };
  },

  computed: {
    supportedBrowsers() {
      return this.$store.state.system.supportedBrowsers;
    },

    supportedBrowsersDisplayList() {
      return Object.keys(this.supportedBrowsers).map((key) => {
        const version = this.supportedBrowsers[key];
        switch (key) {
          case BROWSER.chrome:
            return `Google&nbsp;Chrome&nbsp;${version}+`;
          case BROWSER.firefox:
            return `Mozilla&nbsp;Firefox&nbsp;${version}+`;
          case BROWSER.safari:
            return `Safari&nbsp;${version}+`;
          case BROWSER.edge:
            return `Edge&nbsp;${version}+`;
          case BROWSER.ie:
            return `Internet&nbsp;Explorer&nbsp;${version}`;
          default:
            this.logger.log('unknown browser', {
              name: key,
              version: this.supportedBrowsers[key]
            });
            break;
        }
        return '';
      });
    }
  },

  methods: {
    selectJoinUrl() {
      this.$refs.joinUrl.$el.select();
    },

    clickContinue() {
      this.$store.commit('system/setBrowserCheckStatus',
        { browserCheckStatus: BROWSER_CHECK_STATUS.ok });
    }
  }
};

export default UnsupportedBrowser;
</script>

<style lang="sass">
  @import 'src/scss/variables'
  @import 'src/scss/mixins'

  .unsupported-browser
    display: flex
    flex-direction: column
    align-items: center
    height: 100%
    overflow: auto
    padding: 10px

    > div
      margin-top: auto
      margin-bottom: auto

    input
      border: none
      text-align: center
      margin-top: 10px
      margin-bottom: 10px

    input:focus
      box-shadow: none
      outline: none

    button
      display: block
      margin-left: auto
      margin-right: auto

    .confused-bot
      max-width: 200px
      margin-top: 20px

    @include layout-vertical
      h2
        font-size: 1.5rem

    @include media-breakpoint-down(sm)
      input
        font-size: .8rem
</style>
